import { render, staticRenderFns } from "./UserRolesOptions.vue?vue&type=template&id=14837359&"
import script from "./UserRolesOptions.vue?vue&type=script&lang=ts&"
export * from "./UserRolesOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports